<div class="card-base">
  <div class="card-content">
    <div class="chip-container">
      <mat-chip-list>
        <mat-chip
          color="accent"
          matTooltip="{{ filt.toolTip }}"
          selected
          *ngFor="let filt of searchFilters"
        >
          {{ filt.valueView }}
          <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()"
            >cancel</mat-icon
          >
        </mat-chip>
      </mat-chip-list>
    </div>
    <div class="card-container mat-elevation-z1">
      <div class="clearfix">
        <div class="pull-left div-header-left">
          <app-search-filter-component
            #searchFilter
            (startSearch)="onStartSearch()"
            (endSearch)="onEndSearch($event)"
            [filter]="filters"
          ></app-search-filter-component>
          <study-report-delivery-filter #filters></study-report-delivery-filter>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="card-content margin-botton-medium">
        <p-scrollPanel styleClass="scroll-panel">
          <table
            class="search-table search-table-fixed"
            mat-table
            [dataSource]="dataSource"
          >
            <ng-container matColumnDef="Protocol">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  tile="Protocolo"
                  width="150"
                  #resColProtocol
                ></resizable-column-control>
              </th>
              <td
                (click)="startDeliverty(element)"
                class="search-table-cell"
                mat-cell
                *matCellDef="let element"
              >
                <div>{{ element.Protocol }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="PatientFullName">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  tile="Paciente"
                  width="200"
                  #resColPatientFullName
                ></resizable-column-control>
              </th>
              <td
                (click)="startDeliverty(element)"
                class="search-table-cell"
                mat-cell
                *matCellDef="let element"
              >
                <div>{{ element.PatientFullName }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="PracticeName">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  tile="Práctica"
                  width="200"
                  #resColPracticeName
                ></resizable-column-control>
              </th>
              <td
                (click)="startDeliverty(element)"
                class="search-table-cell"
                mat-cell
                *matCellDef="let element"
              >
                <div>{{ element.PracticeName }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="RegionName">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  tile="Región"
                  width="100"
                  #resColRegionName
                ></resizable-column-control>
              </th>
              <td
                (click)="startDeliverty(element)"
                class="search-table-cell"
                mat-cell
                *matCellDef="let element"
              >
                <div>{{ element.RegionName }}</div>
              </td>
            </ng-container>


            <ng-container matColumnDef="AdminControled">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="30"
                  tile="Ctrl. admin."
                  #resColAdminControled
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>
                  {{ element.AdminControledYesNo }}
                </div>
              </td>
            </ng-container>



            <ng-container matColumnDef="Publicated">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="30"
                  tile="Publicado"
                  #resColPublicated
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>
                  {{ element.PublishedYesNo }}
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="StudyReportStateName">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  tile="Estado"
                  width="150"
                  #resColStudyReportStateName
                ></resizable-column-control>
              </th>
              <td
                (click)="startDeliverty(element)"
                class="search-table-cell"
                mat-cell
                *matCellDef="let element"
              >
                <div>{{ element.StudyReportStateName }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="StudyReportTransitStateName">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  tile="Transito estado"
                  width="150"
                  #resColStudyReportTransitStateName
                ></resizable-column-control>
              </th>
              <td
                (click)="startDeliverty(element)"
                class="search-table-cell"
                mat-cell
                *matCellDef="let element"
              >
                <div>{{ element.StudyReportTransitStateName }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="SectorName">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  tile="Sector"
                  width="150"
                  #resColSectorName
                ></resizable-column-control>
              </th>
              <td
                (click)="startDeliverty(element)"
                class="search-table-cell"
                mat-cell
                *matCellDef="let element"
              >
                <div>{{ element.SectorName }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="RecepcionDate">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  tile="Fecha recepción"
                  width="150"
                  #resColSectorName
                ></resizable-column-control>
              </th>
              <td
                (click)="startDeliverty(element)"
                class="search-table-cell"
                mat-cell
                *matCellDef="let element"
              >
                <div>{{ element.ReceptionDate | date : "dd/MM/yyyy" }}</div>
              </td>
            </ng-container>

            <!-- Star Column -->
            <ng-container matColumnDef="star" stickyEnd>
              <th
                class="search-table-header"
                mat-header-cell
                *matHeaderCellDef
              ></th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <button
                  *ngIf="element.Printable"
                  mat-icon-button
                  [matMenuTriggerFor]="menuItem"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuItem="matMenu">
                  <button
                    *ngIf="
                      element.Printable &&
                      !loadingAction &&
                      element.DeliveryEnabled
                    "
                    mat-menu-item
                    (click)="startDeliverty(element)"
                  >
                    <mat-icon>flag</mat-icon><span>Iniciar entrega</span>
                  </button>
                  <button
                    *ngIf="
                      element.Printable &&
                      !loadingAction &&
                      !element.DeliveryEnabled
                    "
                    mat-menu-item
                    (click)="print(element)"
                  >
                    <mat-icon>printer</mat-icon><span>Imprimir informe</span>
                  </button>
                  <button
                    *ngIf="
                      element.Printable &&
                      !loadingAction &&
                      !element.DeliveryEnabled
                    "
                    mat-menu-item
                    (click)="rollbackDeliverty(element)"
                  >
                    <mat-icon>arrow_back</mat-icon><span>Revertir entrega</span>
                  </button>
                  <button
                    *ngIf="
                      element.Printable &&
                      !loadingAction &&
                      !element.DeliveryEnabled
                    "
                    mat-menu-item
                    (click)="viewObservationDelivery(element)"
                  >
                    <mat-icon>search</mat-icon
                    ><span>Observaciones entrega</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr
              mat-header-row
              class="search-table-header"
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              class="search-table-cell"
              *matRowDef="let row; columns: displayedColumns"
            ></tr>
          </table>
        </p-scrollPanel>
        <pager
          (selectedPageIndexChange)="selectedPageIndexChange($event)"
          #pager
        ></pager>
      </div>
    </div>
  </div>
</div>
